import React, { useState } from "react";
import AlertMsg from "../../Layout/AlertMsg/AlertMsg";
import { forgot, login } from "../../../redux/user/userActions";
import { listDepartments } from "../../../redux/category/categoryActions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Layout/Loader";
import { SimpleInputField } from "../../reusable/InputField/InputField";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();

  const userState = useSelector((state) => state.userState);
  const { loading, error } = userState;

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(login(email, password));
    dispatch(listDepartments());
  };

  const passResetHandler = (e) => {
    e.preventDefault();
    if (!email) {
      alert("Please enter your email first");
    } else {
      dispatch(forgot(email));
    }
  };

  return (
    <div className="dashboard-login">
      {loading && <Loader />}

      <section className="dashboard-login__brand">
        <span>Arktastic</span>
        <div>
          <small>Operations dashboard</small>
          <h1>One place to run the storefront.</h1>
          <p>Commerce, content, customers and the mobile app—kept clear and connected.</p>
        </div>
      </section>

      <section className="dashboard-login__content">
        <div className="dashboard-login__form">
          <header>
            <span>Arktastic admin</span>
            <h2>Welcome back</h2>
            <p>Sign in to continue to the dashboard.</p>
          </header>
          <form onSubmit={submitHandler}>
            <div className="dashboard-login__fields">
              <SimpleInputField
                label="Email"
                placeholder="you@example.com"
                value={email}
                type="email"
                name="email"
                onChange={(e) => setEmail(e.target.value)}
              />
              <SimpleInputField
                label="Password"
                type="password"
                placeholder="Your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="dashboard-login__forgot">
              <button
                type="button"
                onClick={passResetHandler}
                className="dashboard-login__text-button"
              >
                Forgot password?
              </button>
            </div>

            <button
              className="dashboard-login__submit"
              type="submit"
            >
              Sign in
            </button>

            {error && (
              <div className="mt-4">
                <AlertMsg type="error" msg={error} />
              </div>
            )}
          </form>
        </div>
      </section>
    </div>
  );
};

export default Login;
